export class Sound {
  constructor(sources) {
    this.sounds = {};
    for (const [name, file] of Object.entries(sources)) {
      this.sounds[name] = new Audio(file);
    }
  }

  async playOnce(name) {
    this.stopPlay();
    await this.sounds[name].play().catch(this._onPlayErr);
  }

  async startPlay(name) {
    this.stopPlay();
    this.sounds[name].loop = true;
    await this.sounds[name].play().catch(this._onPlayErr);
  }

  _onPlayErr(e) {
    if (e.name === "NotAllowedError") {
      console.info(
        "Open chrome with --autoplay-policy=no-user-gesture-required to always play sounds.",
      );
      return;
    }
    if (e.message.includes("was interrupted")) {
      // happens if we load a running sound.
      return;
    }
    console.error(e);
  }

  stopPlay() {
    for (const [_, sound] of Object.entries(this.sounds)) {
      sound.loop = false;
      sound.load();
      sound.pause();
      sound.currentTime = 0;
    }
  }
}

export async function playOnce(filePath) {
  try {
    const audioElement = new Audio(filePath);
    await audioElement.play();
    return audioElement;
  } catch (e) {
    console.warn("failed to play sound from ", filePath, e);
  }
}
